module.exports = "#campaignForm {\n  padding: 15px 0;\n}\n.input-group-prepend {\n  height: 100%;\n}\nth, td {\n  white-space: initial !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/campaigns/list/campaigns-list.component.css
// module id = ./src/app/components/campaigns/list/campaigns-list.component.css
// module chunks = main